<!--
 * @Descripttion: rest服务控件
 * @Author: zenghua.wang
 * @Date: 2021-07-19 09:23:52
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-10 11:14:01
-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    append-to-body
    center
    width="80%"
  >
    <el-form
      ref="restForm"
      size="small"
      label-width="130px"
      label-position="left"
      label-suffix=":"
      :model="data.apisHttpCtls"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="名称"
            prop="ctlsName"
          >
            <el-input
              placeholder="请输入"
              clearable
              style="width: 100%"
              v-model="data.apisHttpCtls.ctlsName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="URL"
            prop="url"
          >
            <el-input
              placeholder="请输入"
              clearable
              style="width: 100%"
              v-model="data.apisHttpCtls.url"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="请求方式"
            prop="reqMethod"
          >
            <el-select
              style="width: 100%"
              size="small"
              clearable
              placeholder="请选择"
              v-model="data.apisHttpCtls.reqMethod"
            >
              <el-option
                label="GET"
                value="GET"
              ></el-option>
              <el-option
                label="POST"
                value="POST"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="字符集"
            prop="characterSet"
          >
            <el-select
              style="width: 100%"
              size="small"
              clearable
              placeholder="请选择"
              v-model="data.apisHttpCtls.characterSet"
            >
              <el-option
                label="utf-8"
                value="utf-8"
              ></el-option>
              <el-option
                label="gbk"
                value="gbk"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="超时时间(毫秒)"
            prop="timeOut"
          >
            <el-input
              placeholder="请输入"
              clearable
              style="width: 100%"
              v-model="data.apisHttpCtls.timeOut"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="内容类型"
            prop="contentType"
          >
            <el-select
              style="width: 100%"
              size="small"
              clearable
              placeholder="请选择"
              v-model="data.apisHttpCtls.contentType"
            >
              <el-option
                label="application/json"
                value="application/json"
              ></el-option>
              <el-option
                label="application/text"
                value="application/text"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="变量名"
            prop="variableOutRest"
          >
            <el-input
              placeholder="请输入"
              clearable
              style="width: 100%"
              v-model="data.apisHttpCtls.variableOutRest"
            ></el-input>
            <div style="font-size:12px;color:#999">
              注意：变量名不能与表查询输出变量名相同！
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-button
            type="primary"
            size="small"
            :loading="loading"
            @click="onTest"
          >测试接口</el-button>
        </el-col>
      </el-row>
    </el-form>

    <div class="rest-panel">
      <h5 class="rest-panel-title">查询参数</h5>
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="small"
        style="margin-bottom: 20px"
        @click="addParam"
      >新增</el-button>
      <el-table
        size="small"
        tooltip-effect="dark"
        style="width: 100%"
        border
        fit
        :data="data.apisHttpCtlsReqParamList"
      >
        <el-table-column
          label="参数名"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              clearable
              placeholder="请输入"
              v-model="scope.row.param"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="注释"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              clearable
              placeholder="请输入"
              v-model="scope.row.annotation"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="字段类型"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <el-select
              size="small"
              clearable
              style="width:100%"
              placeholder="请选择"
              v-model="scope.row.filedType"
            >
              <el-option
                v-for="(item, index) in options.type"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="参数类型"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <el-select
              clearable
              size="small"
              placeholder="请选择"
              style="width: 100%"
              v-model="scope.row.ginsengType"
            >
              <el-option
                v-for="item in options.paramType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="参数值"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <el-select
              clearable
              size="small"
              placeholder="请选择"
              style="width: 100%"
              v-model="scope.row.paraPath"
              value-key="param"
              @visible-change="onChangeType"
              @change="onChangeParam($event, scope.row)"
            >
              <el-option
                v-for="item in options.paramList"
                :key="item.param"
                :label="item.param"
                :value="item.param"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="参数路径"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              clearable
              placeholder="请输入"
              v-model="scope.row.paraSource"
              @change="onChangeParaPath($event, scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="默认值"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              clearable
              placeholder="请输入"
              v-model="scope.row.defValue"
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          width="80"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="deleteParam(scope.$index)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <span slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="onSubmit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { deepClone, createId, isEmpty } from '@/apisManage/utils'
export default {
  name: 'ApisRest',
  components: {},
  inject: ['main'],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Rest服务'
    },
    tenantId: {
      type: String,
      default: null
    },
    paramList: {
      type: Object,
      default: () => {
        return []
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    change: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      visible: this.show,
      loading: false,
      rules: {
        ctlsName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        url: [{ required: true, message: '请输入url', trigger: 'blur' }],
        reqMethod: [
          { required: true, message: '请选择请求方式', trigger: 'blur' }
        ],
        characterSet: [
          { required: true, message: '请选择字符集', trigger: 'blur' }
        ],
        timeOut: [
          { required: true, message: '请输入超时时间', trigger: 'blur' }
        ],
        contentType: [
          { required: true, message: '请选择内容类型', trigger: 'blur' }
        ],
        variableOutRest: [
          { required: true, message: '请输入变量名', trigger: 'blur' }
        ]
      },
      options: {
        type: [
          {
            label: 'string',
            value: 'string'
          },
          {
            label: 'int',
            value: 'int'
          }
        ],
        paramType: [
          {
            label: 'query',
            value: 'query'
          },
          {
            label: 'body',
            value: 'body'
          },
          {
            label: 'header',
            value: 'header'
          },
          {
            label: 'cookie',
            value: 'cookie'
          }
        ],
        paramList: []
      }
    }
  },
  computed: {},
  watch: {
    show(val) {
      if (val) {
        // 赋值
        this.data.apisHttpCtls.id = this.main.selectCell.id
      }
      this.visible = val
    },
    visible: {
      handler(val) {
        this.$emit('update:show', val)
      },
      deep: true
    }
  },
  methods: {
    onTest() {
      this.$refs.restForm.validate((bool) => {
        if (bool) {
          this.loading = true
          this.$http
            .post('/apis/rest-ctls/stepThrough', this.data)
            .then((res) => {
              if (res.code === 200) {
                this.loading = false
                this.$message({
                  message: '测试成功！',
                  type: 'success'
                })
              }
            })
            .catch((err) => {
              this.loading = false
              this.$message.error('测试失败！失败原因：' + err.msg)
            })
        }
      })
    },
    // 相应切换query、body、cookie、header参数
    onChangeType(type, row) {
      if (!isEmpty(this.paramList)) {
        this.options.paramList = deepClone(this.paramList)
        this.options.paramList.forEach((item) => {
          item.param = '${' + item.param + '}'
        })
      }
    },
    // 切换默认值
    onChangeParam(val, row) {
      this.options.paramList.forEach((item) => {
        if (item.param === val) {
          row.defValue = item.defValue
        }
      })
      if (!isEmpty(val)) {
        row.paraSource = 'req'
      } else {
        row.paraSource = null
        row.defValue = null
      }
    },
    onChangeParaPath(val, row) {
      if (!isEmpty(val)) {
        row.paraPath = ''
      }
    },
    addParam() {
      this.data.apisHttpCtlsReqParamList =
        this.data.apisHttpCtlsReqParamList.filter((item) => {
          return (
            (item.param && item.ginsengType) ||
            item.paraPath ||
            item.defValue ||
            item.paraSource
          )
        })
      this.data.apisHttpCtlsReqParamList.push({
        id: createId(),
        httpCtlsId: this.data.apisHttpCtls.id || createId('http'),
        tenantId: this.tenantId,
        param: null,
        paraSource: null,
        paraPath: null,
        filedType: 'string',
        ginsengType: null,
        defValue: null,
        annotation: null
      })
    },
    deleteParam(index) {
      this.data.apisHttpCtlsReqParamList.splice(index, 1)
    },
    onSubmit() {
      this.$refs.restForm.validate((bool) => {
        if (bool) {
          this.data.apisHttpCtls.createTime = this.main.selectCell.createTime
          if (!isEmpty(this.data.apisHttpCtlsReqParamList)) {
            let bool2 = this.data.apisHttpCtlsReqParamList.every((item) => {
              return item.param && item.ginsengType
            })
            if (!bool2) {
              this.$message.error(
                '每行的参数名、类型为必填字段！参数值、参数路径、默认值为选填一项！'
              )
              return
            }
          }
          this.$emit('change', 'http', this.data)
          this.visible = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.rest {
  &-panel {
    padding: 15px 0;

    &-title {
      text-align: center;
      font-size: 16px;
      color: #3b9cd9;
    }
  }
}
</style>
